import * as constants from './featureFlags.constants';

const INITIAL_STATE = {
  isLoading: false,
  error: null,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case constants.action.FEATURE_FLAGS_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case constants.action.FEATURE_FLAGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        error: null,
      };

    case constants.action.FEATURE_FLAGS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
